import {
  AssemblyType,
  AssemblyTypeValue,
  BackflowAssemblyInfo,
  InstallationStatus,
  InstallationStatusValue,
  JobFormDataBackflow,
  TestResultRp,
} from '../../types/jobFormData';
import { toString } from '../string';

export const isTestable = (testData: JobFormDataBackflow) => {
  return (
    !testData.unableToTest &&
    !testData.improperlyInstalled &&
    testData.installationStatus !== InstallationStatus.REMOVED
  );
};

export const assemblyEdited = (
  installationStatus?: InstallationStatusValue,
  originalAssembly?: Partial<BackflowAssemblyInfo>,
  formAssembly?: Partial<BackflowAssemblyInfo>
) => {
  if (installationStatus === InstallationStatus.REMOVED) {
    return true;
  }

  if (!originalAssembly) {
    return !!formAssembly?.type;
  }

  if (!formAssembly) {
    return false;
  }

  return (
    originalAssembly.modelId != formAssembly.modelId ||
    toString(originalAssembly.serialNumber) !==
      toString(formAssembly.serialNumber) ||
    originalAssembly.size != formAssembly.size ||
    originalAssembly.type != formAssembly.type ||
    toString(originalAssembly.location) !== toString(formAssembly.location)
  );
};

export const getFinalTestDate = (testData: JobFormDataBackflow): string => {
  if (
    !testData.backflowAssembly ||
    !testData.backflowAssembly.type ||
    testData.unableToTest ||
    testData.improperlyInstalled ||
    testData.installationStatus === InstallationStatus.REMOVED
  ) {
    return '';
  }

  const tests = testData.tests;
  if (tests && tests.length > 0) {
    let date = '';

    tests.forEach((testAttempt) => {
      if (
        testData.backflowAssembly?.type &&
        testAttempt.type !== 'repair' &&
        testAttempt.testDate
      ) {
        date = testAttempt.testDate;
      }
    });

    return date;
  }

  return '';
};

export const meterReadingRequired = (type: AssemblyTypeValue): boolean => {
  switch (type) {
    case AssemblyType.RPDA:
    case AssemblyType.RPDA_2:
    case AssemblyType.DCDA:
    case AssemblyType.DCDA_2:
    case AssemblyType.TYPE_2_BYPASS:
      return true;

    case AssemblyType.RP:
    case AssemblyType.DC:
    case AssemblyType.PVB:
    case AssemblyType.SVB:
    case AssemblyType.AIR_GAP:
    case AssemblyType.AVB:
      return false;

    default:
      return false;
  }
};

export const rpOpenedAtRequired = (testAttempt: TestResultRp): boolean => {
  return (
    !testAttempt.didNotOpen &&
    (!testAttempt.reliefValveDripping ||
      testAttempt.reliefValveDripping === 'no' ||
      testAttempt.reliefValveDripping === 'upon_closure')
  );
};

export const rpPressureDropRequired = (testAttempt: TestResultRp): boolean => {
  return (
    !testAttempt.reliefValveDripping ||
    testAttempt.reliefValveDripping === 'no' ||
    testAttempt.reliefValveDripping === 'upon_closure'
  );
};

export const rpCheck2Required = (testAttempt: TestResultRp): boolean => {
  return (
    !testAttempt.reliefValveDripping || testAttempt.reliefValveDripping === 'no'
  );
};
